import { useBackend } from "../../services";
import { ISendEmailProps } from "./useSendEmail";

export const useSendTestEmail = () => {
  const { post } = useBackend();
  return async (props: ISendEmailProps) => post("admin/sendTestEmail", props);
};
